/* Shopify still handles delivery, validation, and spam protection. */
(() => {
  function initialize(root) {
    root.querySelectorAll('.mla-form').forEach(form => {
      if (form.dataset.mlaInitialized) return;
      form.dataset.mlaInitialized = 'true';
      const choices = [...form.querySelectorAll('[data-mla-interests] input[type="checkbox"]')];
      const validate = () => {
        if (choices.length) choices[0].setCustomValidity(
          choices.some(input => input.checked) ? '' : 'Please select at least one area of interest.'
        );
      };
      choices.forEach(input => input.addEventListener('change', validate));
      validate();
      form.querySelector('[data-mla-result]')?.focus();
    });
  }
  if (!window.mlaExpoInitialized) {
    window.mlaExpoInitialized = true;
    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
})();
